import { Expose } from "class-transformer";

export class AssignPlanningBoardWorkshopVehicleDto {
  @Expose()
  vehicleId: string;
}
